// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top action bar — leave the bottom free for player transport controls.
   Same portal root as the fullscreen player so these stay above the overlay. */
.lt-replay-review-actions {
  position: fixed;
  left: 50%;
  top: max(12px, env(safe-area-inset-top, 0px));
  transform: translateX(-50%);
  z-index: 20050;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 10px;
  padding-right: max(10px, calc(56px + env(safe-area-inset-right, 0px)));
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  pointer-events: auto;
  max-width: min(420px, calc(100vw - 24px));
}

.lt-replay-review-actions__queue {
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #f8fafc;
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 82%, #0f172a);
  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 50%, #fff);
}

.lt-replay-review-actions__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #fff);
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 88%, #0f172a);
  color: #f8fafc;
  cursor: pointer;
  flex-shrink: 0;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, transform 0.12s ease, opacity 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease;
}

.lt-replay-review-actions__btn span {
  white-space: nowrap;
}

.lt-replay-review-actions__btn svg {
  color: #f8fafc;
}

.lt-replay-review-actions__btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);
}

.lt-replay-review-actions__btn:active:not(:disabled) {
  transform: scale(0.96);
}

.lt-replay-review-actions__btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.lt-replay-review-actions__btn:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #38bdf8);
  outline-offset: 2px;
}

.lt-replay-review-actions__btn--discard:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #7f1d1d);
  border-color: rgba(248, 113, 113, 0.55);
}

.lt-replay-review-actions__btn--save {
  background: var(--lt-brand, #0877bc);
  border-color: var(--lt-brand, #0877bc);
  color: #fff;
  box-shadow: 0 6px 16px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);
}

.lt-replay-review-actions__btn--save:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 82%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 82%, #fff);
  filter: none;
}

.lt-coach-table--replay {
  position: relative;
  z-index: 4;
}

.lt-coach-table__replay-wrap {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin-left: auto;
  max-width: min(240px, 58%);
  flex-shrink: 0;
  pointer-events: auto;
}

.lt-coach-table__replay {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.22));
  border-radius: 999px;
  padding: 2px 9px;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 700;
  color: #f8fafc;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, rgba(15, 23, 42, 0.85));
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.lt-coach-table__replay:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 48%, rgba(15, 23, 42, 0.9));
}

.lt-coach-table__replay svg {
  font-size: 0.9rem;
}

.lt-coach-table__replay--record {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  border-color: rgba(252, 165, 165, 0.65);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.35);
}

.lt-coach-table__replay--record:hover:not(:disabled) {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.lt-coach-table__replay--starting {
  background: rgba(245, 158, 11, 0.24);
  border-color: rgba(251, 191, 36, 0.65);
  color: #fde68a;
}

.lt-coach-table__replay--stop {
  background: #dc2626;
  border-color: #fca5a5;
  color: #ffffff;
  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.28);
}

.lt-coach-table__camera-online-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.85);
  display: inline-block;
  flex-shrink: 0;
}

.light-mode .lt-coach-table__replay:not(.lt-coach-table__replay--record):not(.lt-coach-table__replay--stop):not(.lt-coach-table__replay--starting),
html[data-theme="light"] .lt-coach-table__replay:not(.lt-coach-table__replay--record):not(.lt-coach-table__replay--stop):not(.lt-coach-table__replay--starting) {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #ffffff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-coach-table__replay--starting,
html[data-theme="light"] .lt-coach-table__replay--starting {
  background: #fef3c7;
  border-color: #f59e0b;
  color: #92400e;
}

.lt-coach-table__replay:disabled {
  opacity: 0.55;
  cursor: default;
}

.lt-coach-table__replay-status {
  font-size: 0.68rem;
  font-weight: 600;
  color: #fbbf24;
}

.lt-coach-table__replay-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  display: inline-block;
  pointer-events: none;
}

.lt-coach-table__replay-error {
  flex: 1 1 100%;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.25;
  color: #fecaca;
  text-align: right;
}

.review-video-fullscreen-player--table-replay {
  z-index: 20000;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingTableReplayReview.css"],"names":[],"mappings":"AAAA;+EAC+E;AAC/E;EACE,eAAe;EACf,SAAS;EACT,6CAA6C;EAC7C,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,sEAAsE;EACtE,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,+EAA+E;EAC/E,kFAAkF;AACpF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kFAAkF;EAClF,+EAA+E;EAC/E,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC;kDACgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;EACX,oFAAoF;AACtF;;AAEA;EACE,kEAAkE;EAClE,oEAAoE;EACpE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6FAA6F;EAC7F,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oFAAoF;EACpF,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;EACvC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qEAAqE;EACrE,uEAAuE;EACvE,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Top action bar — leave the bottom free for player transport controls.\n   Same portal root as the fullscreen player so these stay above the overlay. */\n.lt-replay-review-actions {\n  position: fixed;\n  left: 50%;\n  top: max(12px, env(safe-area-inset-top, 0px));\n  transform: translateX(-50%);\n  z-index: 20050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 8px 10px;\n  padding-right: max(10px, calc(56px + env(safe-area-inset-right, 0px)));\n  border-radius: 14px;\n  background: rgba(15, 23, 42, 0.72);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  pointer-events: auto;\n  max-width: min(420px, calc(100vw - 24px));\n}\n\n.lt-replay-review-actions__queue {\n  min-width: 28px;\n  height: 28px;\n  padding: 0 8px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #f8fafc;\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 82%, #0f172a);\n  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 50%, #fff);\n}\n\n.lt-replay-review-actions__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #fff);\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 88%, #0f172a);\n  color: #f8fafc;\n  cursor: pointer;\n  flex-shrink: 0;\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  -webkit-tap-highlight-color: transparent;\n  transition: background 0.15s ease, transform 0.12s ease, opacity 0.15s ease,\n    border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.lt-replay-review-actions__btn span {\n  white-space: nowrap;\n}\n\n.lt-replay-review-actions__btn svg {\n  color: #f8fafc;\n}\n\n.lt-replay-review-actions__btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);\n}\n\n.lt-replay-review-actions__btn:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.lt-replay-review-actions__btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.lt-replay-review-actions__btn:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #38bdf8);\n  outline-offset: 2px;\n}\n\n.lt-replay-review-actions__btn--discard:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #7f1d1d);\n  border-color: rgba(248, 113, 113, 0.55);\n}\n\n.lt-replay-review-actions__btn--save {\n  background: var(--lt-brand, #0877bc);\n  border-color: var(--lt-brand, #0877bc);\n  color: #fff;\n  box-shadow: 0 6px 16px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);\n}\n\n.lt-replay-review-actions__btn--save:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 82%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 82%, #fff);\n  filter: none;\n}\n\n.lt-coach-table--replay {\n  position: relative;\n  z-index: 4;\n}\n\n.lt-coach-table__replay-wrap {\n  position: relative;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n  margin-left: auto;\n  max-width: min(240px, 58%);\n  flex-shrink: 0;\n  pointer-events: auto;\n}\n\n.lt-coach-table__replay {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, rgba(255, 255, 255, 0.22));\n  border-radius: 999px;\n  padding: 2px 9px;\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #f8fafc;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, rgba(15, 23, 42, 0.85));\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;\n}\n\n.lt-coach-table__replay:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 48%, rgba(15, 23, 42, 0.9));\n}\n\n.lt-coach-table__replay svg {\n  font-size: 0.9rem;\n}\n\n.lt-coach-table__replay--record {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  border-color: rgba(252, 165, 165, 0.65);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.35);\n}\n\n.lt-coach-table__replay--record:hover:not(:disabled) {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n}\n\n.lt-coach-table__replay--starting {\n  background: rgba(245, 158, 11, 0.24);\n  border-color: rgba(251, 191, 36, 0.65);\n  color: #fde68a;\n}\n\n.lt-coach-table__replay--stop {\n  background: #dc2626;\n  border-color: #fca5a5;\n  color: #ffffff;\n  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.28);\n}\n\n.lt-coach-table__camera-online-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #4ade80;\n  box-shadow: 0 0 6px rgba(74, 222, 128, 0.85);\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.light-mode .lt-coach-table__replay:not(.lt-coach-table__replay--record):not(.lt-coach-table__replay--stop):not(.lt-coach-table__replay--starting),\nhtml[data-theme=\"light\"] .lt-coach-table__replay:not(.lt-coach-table__replay--record):not(.lt-coach-table__replay--stop):not(.lt-coach-table__replay--starting) {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #ffffff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, #cbd5e1);\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-coach-table__replay--starting,\nhtml[data-theme=\"light\"] .lt-coach-table__replay--starting {\n  background: #fef3c7;\n  border-color: #f59e0b;\n  color: #92400e;\n}\n\n.lt-coach-table__replay:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.lt-coach-table__replay-status {\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #fbbf24;\n}\n\n.lt-coach-table__replay-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #22c55e;\n  display: inline-block;\n  pointer-events: none;\n}\n\n.lt-coach-table__replay-error {\n  flex: 1 1 100%;\n  font-size: 0.62rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #fecaca;\n  text-align: right;\n}\n\n.review-video-fullscreen-player--table-replay {\n  z-index: 20000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
